// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={299.999}
      height={162.239}
      viewBox="0 0 239.999 129.791"
      {...props}
    >
      <path
        fill="#fff"
        stroke="#1ca3db"
        strokeWidth={0.361}
        d="M3.723 3.664h232.969v122.661H3.723z"
      />
      <g fill="#00a4e4">
        <path d="M0 64.896v64.895h240V0H0v64.896zm230.994 0v55.747H8.862V9.148h222.132v55.748z" />
        <path d="M174.246 27.245c-3.073.271-6.575.972-9.262 1.844-5.675 1.83-10.02 4.488-14.252 8.72-4.888 4.888-8.047 10.477-9.806 17.31-.972 3.845-1.186 5.688-1.186 10.348-.014 4.231.1 5.39.772 8.677 1.186 5.718 3.974 11.478 7.69 15.91 1.458 1.729 4.603 4.788 6.218 6.046 5.275 4.102 11.478 6.532 18.568 7.247 2.559.272 8.148.114 10.406-.272 5.432-.943 10.235-2.944 14.237-5.96 5.675-4.274 10.006-10.52 12.065-17.41 1.143-3.846 1.572-6.862 1.672-12.065l.086-3.745h-30.347V74.33h9.149c7.218 0 9.148.043 9.148.171 0 .443-.872 3.574-1.272 4.589-1.601 4.016-4.374 7.619-7.662 9.949-1.386.972-4.145 2.372-5.646 2.858-5.89 1.901-12.836 1.344-18.654-1.5-7.333-3.574-12.493-10.478-14.137-18.897-1.043-5.346-.629-11.407 1.115-16.396 3.373-9.663 11.192-15.995 21.284-17.239 2.116-.257 6.775-.1 8.734.3 6.49 1.301 12.107 4.903 16.31 10.478l.828 1.115 1.015-.986c.558-.53 2.33-2.23 3.946-3.76 1.615-1.53 2.944-2.816 2.973-2.858.086-.2-2.302-3.002-3.845-4.503-3.803-3.702-8.891-6.79-13.994-8.49-4.146-1.387-7.147-1.873-12.008-1.93-1.93-.015-3.787-.015-4.145.014zM63.71 29.618c-.187.414-7.977 16.952-17.311 36.736-9.32 19.797-16.953 36.021-16.953 36.064 0 .043 2.745.057 6.104.043l6.089-.043 4.017-8.891 4.016-8.891 15.581-.014h15.595l3.874 8.89 3.873 8.906 6.09.043c3.345.014 6.089-.015 6.089-.057 0-.115.457.9-23.228-51.874-3.273-7.319-6.775-15.095-7.747-17.296-.987-2.201-1.859-4.088-1.93-4.188-.115-.115-.686-.172-1.973-.172h-1.844l-.343.744zm7.118 31.776c2.873 6.503 5.203 11.864 5.174 11.892-.028.029-4.86.029-10.72.015l-10.664-.043 5.446-11.907c2.988-6.547 5.46-11.879 5.49-11.85.028.028 2.4 5.374 5.274 11.893zM113.353 66.11v36.236H124.502V29.875H113.353V66.11z" />
      </g>
    </svg>
  );
};

const AigIcon = Icon;
export default AigIcon;
